import React from "react";
import { Link } from 'gatsby';

import TitleImage from '../images/Landing_Top_logo.svg';
import SearchIcon from '../images/Icon_search.svg';
import '../styles/topbar.css';


export default () => <div className='topbar'>
	<Link to='/'>
        <img className='topbar-title' src={TitleImage} />
    </Link>

    <div className="search-area">
        <img src={SearchIcon} />
        <input type="search" placeholder="Search..." />
    </div>
</div>